import {
  Modal,
  Platform,
  Pressable,
  SafeAreaView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import {
  color_333333,
  color_main,
  ColorC5EAE1,
  white,
} from "../assets/style/colors";
import React, { useEffect, useMemo, useRef, useState } from "react";
import QRCode from "react-native-qrcode-svg";
import { LeftView } from "./Chat/CListItem";
import {
  Str_GroupQrCode,
  Str_MyQRCode,
  Str_QRCodeError,
} from "../language/string_res";
import { getUserName } from "./Chat/chat-helper";
import * as ImSdk from "../../imsdk/api";
import { MainNavProps } from "./navigation/main/MainParamList";
import LogoIcon from "../assets/svg/ic_round_logo.svg";
import LogoIconMiso from "../assets/svg/ic_round_logo_miso.svg";
export function QRCodeScreenModal({
  navigation,
  route,
}: MainNavProps<"QRCodeScreen">) {
  const [group, setGroup] = useState(route.params.group);
  const [user, setUser] = useState(route.params.user);
  const isHadUpdate = useRef(false);
  const { avatar, name, qrcode_desc, qrcode, isGroup } = useMemo(() => {
    const avatar = group?.avatar || user?.avatar;
    const name = group?.remark || group?.name || getUserName(user);
    const qrcode_desc = group?.qrcode_desc || user?.qrcode_desc;
    const qrcode = group?.qrcode || user?.qrcode;
    let isGroup = false;
    if (group) {
      isGroup = true;
    }

    return { avatar, name, qrcode_desc, qrcode, isGroup };
  }, [user, group]);

  useEffect(() => {
    if (isHadUpdate.current) {
      return;
    }

    isHadUpdate.current = true;

    const im = ImSdk.getInstance();
    if (group) {
      im.GetGroupRemote(group.tid).then((r) => {
        if (r.group) {
          setGroup(r.group);
        }
      });
    }
    if (user) {
      im.GetUserRemote(user.uid).then((r) => {
        if (r.users && r.users.length > 0) {
          setUser(r.users[0]);
        }
      });
    }
  }, [group, user]);
  const onClose = () => {
    navigation.goBack();
  };
  return (
    <TouchableOpacity
      style={{
        flex: 1,
        backgroundColor: "rgba(0,0,0,0.5)",
        justifyContent: "center",
        alignItems: "center",
      }}
      activeOpacity={1}
      onPress={onClose}
    >
      <SafeAreaView
        style={{
          width: "85%",
          maxWidth: 500,
          backgroundColor: ColorC5EAE1,
          borderRadius: 20,
          paddingBottom: 24,
          shadowColor: "#000",
          shadowOffset: { width: 0, height: 4 },
          shadowOpacity: 0.3,
          shadowRadius: 8,
          elevation: 8,
        }}
      >
        <View style={{ alignItems: "flex-end", padding: 16 }}>
          <Pressable
            onPress={onClose}
            style={{
              padding: 8,
              width: 32,
              height: 32,
              borderRadius: 16,
              backgroundColor: "rgba(0,0,0,0.2)",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text style={{ fontSize: 20, color: white, fontWeight: "bold" }}>
              ×
            </Text>
          </Pressable>
        </View>
        <View
          style={{
            backgroundColor: white,
            borderRadius: 20,
            alignItems: "center",
            paddingBottom: 28,
            paddingTop: 24,
            paddingHorizontal: 32,
            marginHorizontal: 16,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.1,
            shadowRadius: 8,
            elevation: 4,
          }}
        >
          <View style={{ marginTop: -60, paddingStart: 12 }}>
            <LeftView
              left={{ name: name, avatar: avatar, uid: user?.uid || 0 }}
              size={100}
              isRounded={true}
              isGroup={isGroup}
            />
          </View>
          <Text
            numberOfLines={2}
            ellipsizeMode={"tail"}
            style={{
              color: "#1A1A1A",
              fontSize: 18,
              fontWeight: "600",
              textAlign: "center",
              width: "100%",
              marginBottom: 20,
              marginTop: 12,
              letterSpacing: 0.3,
            }}
          >
            {name}
          </Text>

          {qrcode && qrcode.length > 0 ? (
            <View
              style={{
                backgroundColor: white,
                padding: 16,
                borderRadius: 12,
                borderWidth: 1,
                borderColor: "#F0F0F0",
              }}
            >
              <View
                style={{
                  width: 240,
                  height: 240,
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: white,
                }}
              >
                <QRCode value={qrcode} size={240} logoSVG={ImSdk.isMiso ? LogoIconMiso : LogoIcon} />
              </View>
            </View>
          ) : (
            <View
              style={{
                width: 240,
                height: 240,
                backgroundColor: "#F5F5F5",
                borderRadius: 12,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text
                style={{
                  color: color_333333,
                  textAlign: "center",
                  fontSize: 14,
                  padding: 20,
                }}
              >
                {Str_QRCodeError}
              </Text>
            </View>
          )}
          {qrcode_desc && (
            <Text
              style={{
                marginTop: 20,
                color: "#888888",
                marginHorizontal: 20,
                textAlign: "center",
                fontSize: 13,
                lineHeight: 20,
              }}
            >
              {qrcode_desc}
            </Text>
          )}
        </View>
      </SafeAreaView>
    </TouchableOpacity>
  );
}
